import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AccountStore } from './account-store';
import { PdRoutes } from './routes';

export type CanActivateResult =
  | boolean
  | UrlTree
  | Observable<boolean | UrlTree>;

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    protected pdRoutes: PdRoutes,
    protected accountStore: AccountStore
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): CanActivateResult {
    const token = this.accountStore.accessToken;
    const isAuthenticated = !!token;
    if (!isAuthenticated) {
      return this.pdRoutes.root().urlTree;
    }
    return isAuthenticated;
  }
}
